import _regeneratorRuntime from "@babel/runtime/regenerator";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { MobileAutoSuggestStyle } from './styles';
import { TextInput, VisuallyHidden } from '@olxbr/ds-web';
import SearchIcon from '@olxbr/olx-icons/dist/System/Search';
import ArrowLeft from '@olxbr/olx-icons/dist/System/ArrowLeft';
import OraculoHistoryItem from '../components/OraculoHistoryItem';
import OraculoCategoryItem from '../components/OraculoCategoryItem';
import { hasCategory, getCategorySuggestions } from '../utils/categorySuggestions';
import { SearchHistoryModule } from '../utils/searchHistory';
import { sendTracking, formatSubmitTrackingPayload, formatCategorySuggestionTrackingPayload, formatHistorySuggestionTrackingPayload } from '../utils/events';
import { debounceCall } from '../utils/extras'; // import { getQueryFromDataLayer } from '../index'

var OraculoMobileContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  background-color: white;\n  flex: 1;\n"])));
var SearchContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  background-color: white;\n  padding: var(--spacing-stack-xxxs);\n  border-bottom: solid 1px var(--color-neutral-medium);\n"])));
var BackButton = styled.button(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background: white;\n  margin-right: var(--spacing-inset-md);\n  cursor: pointer;\n  height: 38px;\n  width: 30px;\n\n  &> div {\n    width: 24px;\n    height: 24px;\n\n    &> svg {\n      color: var(--color-neutral-darkest);\n    }\n  }\n"])));
var SearchInput = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  flex: 1;\n"])));
var CustomTextInput = styled(TextInput)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n  > span {\n    &:hover {\n      box-shadow: 0 0 0 var(--border-width-thin) var(--color-secondary-medium);\n    }\n\n    &:focus,\n    &:visited {\n      box-shadow: 0 0 0 var(--border-width-hairline) var(--color-secondary-medium);\n    }\n  }\n"])));
var SubmitButton = styled.button(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n  background: white;\n  position: absolute;\n  cursor: pointer;\n  border: none;\n\n  right: 6px;\n  top: 4px;\n  height: 38px;\n  width: 38px;\n  border-radius: var(--border-radius-lg);\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  outline: none;\n  text-align: center;\n  transition: var(--transition-duration-fast);\n  z-index: var(--z-index-1-default);\n\n  &> div {\n    width: 24px;\n    height: 24px;\n\n    &> svg {\n      color: var(--color-neutral-darker);\n    }\n  }\n\n  &:hover {\n    background: var(--color-neutral-light);\n    svg {\n      color: #6b6b6b;\n    }\n  }\n\n  &:focus {\n    background: #6e0ad6;\n\n    svg {\n      color: #fff;\n    }\n  }\n"])));
var SuggestionsContainer = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  justify-content: flex-start;\n  padding-top: 4px;\n"])));

var OraculoMobile = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(OraculoMobile, _React$Component);

  function OraculoMobile(props) {
    var _this;

    _this = _React$Component.call(this, props) || this; // const query = this.props.defaultValue || getQueryFromDataLayer() || ''

    _defineProperty(_assertThisInitialized(_this), "onSuggestionCategorySelected", function (event, _ref) {
      var suggestion = _ref.suggestion,
          suggestionIndex = _ref.suggestionIndex,
          submitMethod = _ref.submitMethod;
      var _this$state = _this.state,
          searchHistoryModule = _this$state.searchHistoryModule,
          categorySuggestions = _this$state.categorySuggestions,
          historySuggestions = _this$state.historySuggestions,
          inputRef = _this$state.inputRef;
      searchHistoryModule.addHistoryItem(suggestion.query);
      sendTracking(formatCategorySuggestionTrackingPayload({
        typedQuery: (inputRef === null || inputRef === void 0 ? void 0 : inputRef.value) || '',
        suggestion: suggestion,
        lurkerObjectName: _this.props.lurkerObjectName,
        submitMethod: submitMethod,
        applicationAppliedCategory: _this.getApplicationAppliedCategory(),
        suggestionIndex: suggestionIndex,
        categorySuggestions: categorySuggestions,
        historySize: historySuggestions.length
      }));

      if (inputRef) {
        inputRef.value = suggestion.query;
      }

      _this.hideSuggestions();

      var onSubmit = _this.props.onSubmit;

      if (onSubmit) {
        event.preventDefault();
        onSubmit(event, suggestion.query, suggestion.category_id);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onHistorySuggestionSelected", function (event, _ref2) {
      var suggestion = _ref2.suggestion,
          suggestionIndex = _ref2.suggestionIndex,
          submitMethod = _ref2.submitMethod;
      var _this$state2 = _this.state,
          searchHistoryModule = _this$state2.searchHistoryModule,
          historySuggestions = _this$state2.historySuggestions,
          inputRef = _this$state2.inputRef;
      searchHistoryModule.addHistoryItem(suggestion);
      sendTracking(formatHistorySuggestionTrackingPayload({
        typedQuery: (inputRef === null || inputRef === void 0 ? void 0 : inputRef.value) || '',
        suggestion: suggestion,
        lurkerObjectName: _this.props.lurkerObjectName,
        submitMethod: submitMethod,
        applicationAppliedCategory: _this.getApplicationAppliedCategory(),
        suggestionIndex: suggestionIndex,
        historySuggestions: historySuggestions
      }));

      if (inputRef) {
        inputRef.value = suggestion;
      }

      _this.hideSuggestions();

      var onSubmit = _this.props.onSubmit;

      if (onSubmit) {
        event.preventDefault();
        onSubmit(event, suggestion, _this.getApplicationAppliedCategory());
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSuggestionsFetchRequested", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3) {
        var value, _this$props, categoryMaxSuggestions, url, testId, categoryIdFilter, searchHistoryModule, response, historySuggestions, categorySuggestions;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                value = _ref3.value;
                _this$props = _this.props, categoryMaxSuggestions = _this$props.categoryMaxSuggestions, url = _this$props.url, testId = _this$props.testId, categoryIdFilter = _this$props.categoryIdFilter;
                searchHistoryModule = _this.state.searchHistoryModule;
                _context.next = 5;
                return getCategorySuggestions(url, value, _this.state.currentCategoryId, testId, categoryIdFilter);

              case 5:
                response = _context.sent;
                historySuggestions = searchHistoryModule.getHistorySuggestions(value);

                if (response.suggestions !== _this.state.categorySuggestions) {
                  categorySuggestions = response.suggestions.slice(0, categoryMaxSuggestions);

                  _this.setState({
                    lastValidQuery: value,
                    categorySuggestions: categorySuggestions,
                    historySuggestions: historySuggestions
                  });
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "debounceSuggestionsFetchRequest", debounceCall(_this.onSuggestionsFetchRequested, _this.props.debounceTime));

    _defineProperty(_assertThisInitialized(_this), "hideSuggestions", function () {
      _this.setState({
        categorySuggestions: [],
        historySuggestions: []
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderSuggestion", function (suggestion, query, index) {
      var searchHistoryModule = _this.state.searchHistoryModule;
      var categoryIdFilter = _this.props.categoryIdFilter;
      var boldSugg = suggestion.query.trim().slice(query.trim().length);
      return hasCategory(suggestion) ? /*#__PURE__*/React.createElement(OraculoCategoryItem, {
        key: index,
        query: query,
        boldSugg: boldSugg,
        suggestion: suggestion,
        homeStyle: true,
        indexPosition: index,
        categoryIdFilter: categoryIdFilter,
        onClick: _this.onSuggestionCategorySelected
      }) : /*#__PURE__*/React.createElement(OraculoHistoryItem, {
        key: index,
        query: query,
        boldSugg: boldSugg,
        suggestion: suggestion,
        homeStyle: true,
        indexPosition: index,
        onClick: _this.onHistorySuggestionSelected,
        closeSize: 14,
        deleteHistoryItem: function deleteHistoryItem(e) {
          searchHistoryModule.deleteHistoryItem(e, suggestion.query, query, _this.props.lurkerObjectName);

          _this.setState({
            historySuggestions: searchHistoryModule.historySuggestions
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyPress", function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();

        _this.handleSubmit(event, 'enter');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onBackPress", function () {
      var inputRef = _this.state.inputRef;

      if (_this.props.onBack) {
        _this.props.onBack((inputRef === null || inputRef === void 0 ? void 0 : inputRef.value) || '');
      }
    });

    var _query = _this.props.defaultValue || '';

    _this.state = {
      lastValidQuery: _query,
      currentCategoryId: _this.props.currentCategoryId,
      categorySuggestions: [],
      historySuggestions: [],
      historyTrie: null,
      suggestion: null,
      inputRef: null
    };
    _this.handleInputChange = _this.handleInputChange.bind(_assertThisInitialized(_this));
    _this.handleSubmit = _this.handleSubmit.bind(_assertThisInitialized(_this));
    _this.wrapperRef = React.createRef();
    return _this;
  } // Category suggestions


  var _proto = OraculoMobile.prototype;

  // History suggestions
  _proto.setSearchHistoryModule = function setSearchHistoryModule() {
    var _this$props2 = this.props,
        lurkerId = _this$props2.lurkerId,
        historyMaxWords = _this$props2.historyMaxWords,
        historyMaxSuggestions = _this$props2.historyMaxSuggestions,
        initialHistoryMaxSuggestions = _this$props2.initialHistoryMaxSuggestions,
        categoryIdFilter = _this$props2.categoryIdFilter;
    var hideSuggestions = categoryIdFilter != null;
    this.setState({
      searchHistoryModule: new SearchHistoryModule({
        lurkerId: lurkerId,
        historyMaxWords: historyMaxWords,
        historyMaxSuggestions: historyMaxSuggestions,
        initialHistoryMaxSuggestions: initialHistoryMaxSuggestions,
        hideSuggestions: hideSuggestions
      })
    });
  };

  // General
  _proto.getApplicationAppliedCategory = function getApplicationAppliedCategory() {
    return this.props.currentCategoryId || '';
  };

  _proto.handleInputChange = function handleInputChange(event) {
    var query = event.target.value;
    if (!event) this.debounceSuggestionsFetchRequest();
    this.debounceSuggestionsFetchRequest({
      value: query
    });
  };

  _proto.handleSubmit = function handleSubmit(event, submitMethod) {
    event.persist();
    var _this$state3 = this.state,
        searchHistoryModule = _this$state3.searchHistoryModule,
        categorySuggestions = _this$state3.categorySuggestions,
        historySuggestions = _this$state3.historySuggestions,
        inputRef = _this$state3.inputRef;
    var typedQuery = (inputRef === null || inputRef === void 0 ? void 0 : inputRef.value) || '';
    searchHistoryModule.addHistoryItem(typedQuery);
    sendTracking(formatSubmitTrackingPayload({
      query: typedQuery,
      lurkerObjectName: this.props.lurkerObjectName,
      submitMethod: submitMethod,
      applicationAppliedCategory: this.getApplicationAppliedCategory(),
      categorySuggestions: categorySuggestions,
      historySuggestions: historySuggestions
    }));
    var onSubmit = this.props.onSubmit;

    if (onSubmit) {
      onSubmit(event, typedQuery, this.props.currentCategoryId);
    }

    this.hideSuggestions();
  };

  _proto.componentDidMount = function componentDidMount() {
    var _this$wrapperRef, _this$wrapperRef$curr;

    this.setSearchHistoryModule();
    var inputRef = (_this$wrapperRef = this.wrapperRef) === null || _this$wrapperRef === void 0 ? void 0 : (_this$wrapperRef$curr = _this$wrapperRef.current) === null || _this$wrapperRef$curr === void 0 ? void 0 : _this$wrapperRef$curr.querySelector('input');

    if (inputRef) {
      this.setState({
        inputRef: inputRef
      });
      inputRef.focus();
    }

    var query = (inputRef === null || inputRef === void 0 ? void 0 : inputRef.value) || '';
    this.debounceSuggestionsFetchRequest({
      value: query
    });
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.lurkerId !== prevProps.lurkerId) {
      this.setSearchHistoryModule();
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$state4 = this.state,
        historySuggestions = _this$state4.historySuggestions,
        categorySuggestions = _this$state4.categorySuggestions;
    var suggestions = [].concat(historySuggestions, categorySuggestions);
    var optionsList = suggestions.map(function (suggestion, index) {
      return _this2.renderSuggestion(suggestion, _this2.state.lastValidQuery, index);
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "oraculo-mobile",
      ref: this.wrapperRef
    }, /*#__PURE__*/React.createElement(MobileAutoSuggestStyle, {
      id: "listing-autosuggest--mobile"
    }), /*#__PURE__*/React.createElement(OraculoMobileContainer, null, /*#__PURE__*/React.createElement(SearchContainer, null, /*#__PURE__*/React.createElement(BackButton, {
      onClick: this.onBackPress
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ArrowLeft, null)), /*#__PURE__*/React.createElement(VisuallyHidden, null, "Voltar")), /*#__PURE__*/React.createElement(SearchInput, null, /*#__PURE__*/React.createElement(CustomTextInput, {
      id: "search-input",
      "aria-label": "Campo de busca",
      autoComplete: "off",
      spellCheck: false,
      defaultValue: this.props.defaultValue,
      onChange: this.handleInputChange,
      onKeyPress: this.handleKeyPress
    }), /*#__PURE__*/React.createElement(SubmitButton, {
      onClick: function onClick(e) {
        return _this2.handleSubmit(e, 'search_button_click');
      }
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SearchIcon, null)), /*#__PURE__*/React.createElement(VisuallyHidden, null, "Buscar")))), /*#__PURE__*/React.createElement(SuggestionsContainer, null, optionsList)));
  };

  return OraculoMobile;
}(React.Component);

OraculoMobile.propTypes = process.env.NODE_ENV !== "production" ? {
  defaultValue: PropTypes.string,
  url: PropTypes.string,
  currentCategoryId: PropTypes.any,
  onChange: PropTypes.func,
  testId: PropTypes.string,
  onSubmit: PropTypes.func,
  onBack: PropTypes.func,
  // initialFocus: PropTypes.any,
  placeholder: PropTypes.string,
  lurkerId: PropTypes.string,
  categoryIdFilter: PropTypes.string,
  historyMaxWords: PropTypes.number,
  historyMaxSuggestions: PropTypes.number,
  categoryMaxSuggestions: PropTypes.number,
  initialHistoryMaxSuggestions: PropTypes.number,
  debounceTime: PropTypes.number,
  lurkerObjectName: PropTypes.string
} : {};
OraculoMobile.defaultProps = {
  placeholder: 'Buscar',
  url: 'https://oraculo.olx.com.br/',
  // initialFocus: false,
  lurkerId: 'common-user',
  historyMaxWords: 100,
  historyMaxSuggestions: 3,
  categoryMaxSuggestions: 5,
  initialHistoryMaxSuggestions: 8,
  debounceTime: 200,
  lurkerObjectName: 'listing'
};
export default OraculoMobile;